const IDENTITY_URL = process.env.REACT_APP_IDENTITY_URL || process.env.NEXT_PUBLIC_IDENTITY_URL || "";
const MESSAGE_API_URL = process.env.REACT_APP_MESSAGE_API_URL || process.env.NEXT_PUBLIC_MESSAGE_API_URL || "";
const MESSAGE_HUB_URL = process.env.REACT_APP_MESSAGE_HUB_URL || process.env.NEXT_PUBLIC_MESSAGE_HUB_URL || "";
const COMMON_API_URL = process.env.REACT_APP_COMMON_API_URL || process.env.NEXT_PUBLIC_COMMON_API_URL || "";
const APOLLO_API_URL = process.env.REACT_APP_APOLLO_API_URL || process.env.NEXT_PUBLIC_APOLLO_API_URL || "";
const ASSET_API_URL = process.env.REACT_APP_ASSET_API_URL || process.env.NEXT_PUBLIC_ASSET_API_URL || "";
const SALE_API_URL = process.env.REACT_APP_SALE_API_URL || process.env.NEXT_PUBLIC_SALE_API_URL || "";


const IDENTITY_API_URL = IDENTITY_URL + "/api";

export {
    MESSAGE_HUB_URL,
    MESSAGE_API_URL,
    APOLLO_API_URL,
    ASSET_API_URL,
    IDENTITY_API_URL,
    SALE_API_URL,
    COMMON_API_URL,
};

export const Constants = {
    Api: {
        TIMEOUT: 25 * 1000,
    },

    DefaultLanguage: "vi",
    LanguageContent: {
        VI: "vi",
        EN: "en",
    },

    DateFormat: {
        DDMM: "DD/MM",
        MMYYYY: "MM/YYYY",
        DDMMYYYY: "DD/MM/YYYY",
        DDMMYYYY_HHMM: "DD/MM/YYYY HH:mm",
        DDMMYYYY_HHMMSS: "DD/MM/YYYY HH:mm:ss",
        HHMM_DDMMYYYY: "HH:mm DD/MM/YYYY",
        HHMM: "HH:mm",
        HHMMSS: "HH:mm:ss",
        YYYY: "YYYY",
        YYYYMM: "YYYY/MM",
        YYYYMMDD: "YYYY/MM/DD",
        YYYYMMDD_HHMM: "YYYY/MM/DD HH:mm",
        DDDD: "dddd",
    },

    ALL: 999,
    ROW_PER_PAGE: 20,
    ROW_PER_PAGE_50: 50,
    ROW_PER_PAGE_OPTIONS: [20, 50, 100],

    FolderPath: "/temp",

    ApiPath: {
        // GROUP 
        GROUP: {
            GET_PAGED: "/Group/GetPaged",
            GET_ALL: "/Group/GetAll",
        },

        // USER
        USER: {
            GET_PAGED: "/User/GetPaged",
        },

        // Resource 
        RESOURCE: {
            GET_PAGED_SERVICE: "/Resource/GetPagedService",
            GET_DETAIL: "/Resource/Detail",
        },

        // ASSET
        ASSET: {
            GET_ASSET_INFO: "/GetAssetInfo",
            GET_ASSET_ACCESS_URL: "/GetAccessUrl",
            GET_ASSET_DOWNLOAD_URL: "/GetDownloadUrl",
            GET_EXTERNAL_URL_IDS: "/GetExternalUrlIds",
            CREATE_URL_ASSET: "/CreateUrlAsset",
            SET_ACTIVE_BY_ID: "/SetActiveById",
            GET_M3U8_URL: "/GetM3u8Url",
            UPDATE_RESOURCE_CODE: "/UpdateAssetResourceCode",
        },

        SYSTEM_SETTING: {
            CREATE: "/SystemSetting/Create",
            UPDATE: "/SystemSetting/Update",
            UPDATE_MULTI: "/SystemSetting/UpdateMulti",
            GET_SYSTEM_SETTING: "/SystemSetting/GetSystemSetting",
            GET_BY_SETTING_CODE: "/SystemSetting/GetBySettingCode",
            GET_BY_SETTING_CODES: "/SystemSetting/GetBySettingCodes",
        },

        NOTIFICATION: {
            CREATE: "/Message/CreateNotification",
            GET_PAGED: "/Message/GetPaged",
            READ_MESSAGE: "/Message/ReadMessage",
            DETAIL_MESSAGE: "/Message/DetailMessage",
            READ_ALL_MESSAGE: "/Message/ReadAllMessage",
            DELETE_ALL_MESSAGE: "/Message/DeleteAllMessage",
            REGISTER: "/Message/Register",
            UN_REGISTER: "/Message/Unregister",
        },

        MESSAGE_TEMPLATE: {
            GET_PAGED: "/MessageTemplate/GetPaged",
            GET_ALL: "/MessageTemplate/GetAll",
            DETAIL: "/MessageTemplate/Detail",
            CREATE: "/MessageTemplate/Create",
            UPDATE: "/MessageTemplate/Update",
            DELETE: "/MessageTemplate/Delete",
        },

        MESSAGE_TEMPLATE_CASE: {
            GET_PAGED: "/MessageTemplateCase/GetPaged",
            DETAIL: "/MessageTemplateCase/Detail",
            CREATE: "/MessageTemplateCase/Create",
            UPDATE: "/MessageTemplateCase/Update",
            DELETE: "/MessageTemplateCase/Delete",
        },

        TEMPLATE_CASE_KEYWORD: {
            GET_BY_TARGET_ID: "/TemplateCaseKeyword/GetByTargetId",
            DELETE: "/TemplateCaseKeyword/Delete",
            CREATE: "/TemplateCaseKeyword/Create",
            UPDATE: "/TemplateCaseKeyword/Update",
        },

        CODENAME: {
            GET_BY_GROUP: "/Codename/GetByGroup",
            GET_PAGED: "/Codename/GetPaged",
            GET_DETAIL: "/Codename/Detail",
            CREATE: "/Codename/Create",
            UPDATE: "/Codename/Update",
            DELETE: "/Codename/Delete",
        },

        // APOLLO
        // post
        POST: {
            GET_PAGED: "/Post/GetPaged",
            GET_DETAIL: "/Post/Detail",
            CREATE: "/Post/Create",
            UPDATE: "/Post/Update",
            DELETE: "/Post/Delete",
            PUBLISH: "/Post/Publish",
            UNPUBLISH: "/Post/Unpublish",

            // 
            GET_COMMUNITY_POST_PAGED: "/Post/GetCommunityPostPaged",
            GET_COMMUNITY_POST_DETAIL: "/Post/CommunityPostDetail",
            CREATE_COMMUNITY_POST: "/Post/CreateCommunityPost",
            UPDATE_COMMUNITY_POST: "/Post/UpdateCommunityPost",
            DELETE_COMMUNITY_POST: "/Post/DeleteCommunityPost",
            UN_FOLLOW: "/Post/UnFollow",
            FOLLOW: "/Post/Follow",
        },
        // codename
        CODE_NAME: {
            GET_BY_GROUP: "/Codename/GetByGroup",
        },

        // tag
        TAG: {
            GET_ALL: "/Tag/GetAll",
            GET_PAGED: "/Tag/GetPaged",
            DETAIL: "/Tag/Detail",
            CREATE: "/Tag/Create",
            UPDATE: "/Tag/Update",
            DELETE: "/Tag/Delete",
        },

        TOPIC: {
            GET_PAGED: "/Topic/GetPaged",
            GET_PAGED_USER_TOPIC: "/Topic/GetPagedUserTopic",
            GET_DETAIL: "/Topic/Detail",
            CREATE: "/Topic/Create",
            UPDATE: "/Topic/Update",
            DELETE: "/Topic/Delete",
            SUBSCIBE: "/Topic/Subscibe",
            UNSUBSCIBE: "/Topic/UnSubscibe",
            BLOCK_USER_TOPIC: "/Topic/BlockUserTopic",
        },

        CATEGORY: {
            GET_ALL: "/Category/GetAll",
            GET_PAGED: "/Category/GetPaged",
            GET_DETAIL: "/Category/Detail",
            CREATE: "/Category/Create",
            UPDATE: "/Category/Update",
            DELETE: "/Category/Delete",
        },

        CHANNEL: {
            GET_PAGED: "/Channel/GetPaged",
            GET_MEMBER_PAGED: "/Channel/GetMemberPaged",
            GET_DETAIL: "/Channel/Detail",
            CREATE: "/Channel/Create",
            UPDATE: "/Channel/Update",
            DELETE: "/Channel/Delete",
            JOIN: "/Channel/Join",
        },

        COMMUNITY: {
            GET_PAGED: "/Community/GetPaged",
            GET_DETAIL: "/Community/Detail",
            CREATE: "/Community/Create",
            UPDATE: "/Community/Update",
            DELETE: "/Community/Delete",
            PUBLISH: "/Community/Publish",
            UNPUBLISH: "/Community/Unpublish",
            JOIN: "/Community/Join",
        },

        FAQ: {
            GET_PAGED: "/Faq/GetPaged",
            GET_DETAIL: "/Faq/Detail",
            CREATE: "/Faq/Create",
            UPDATE: "/Faq/Update",
            DELETE: "/Faq/Delete",
        },

        // ITEM
        ITEM: {
            GET_ALL: "/Item/GetAll",
            GET_PAGED: "/Item/GetPaged",
        },

        Guest: {
            CREATE: "/Guest/Create",
        },

        Reaction: {
            GET_ALL: "/Reaction/GetAll",
        },

        Discussion: {
            GET_PAGED: "/Discussion/GetPaged",
            GET_MEMBERS_PAGED: "/Discussion/GetMemberPaged",
            CREATE: "/Discussion/Create",
            UPDATE: "/Discussion/Update",
            DELETE: "/Discussion/Delete",
        },

        DiscussionGroup: {
            GET_MEMBERS_PAGED: "/DiscussionGroup/GetMemberPaged",
        },

        UserReaction: {
            REACTION: "/UserReaction/Reaction",
            UNREACTED: "/UserReaction/Unreacted",
        },

        TENANT: {
            GET_ALL: "/Tenant/GetAll",
        },

        SERVICE: {
            GET_ALL: "/Service/GetAll",
        },
    },

    ChatHubName: {
        GET_CONNECTION: "GetConnectionId",
        SEND_MESSAGE: "SendMessage",
        UPDATE_MESSAGE: "UpdateMessage",
        JOIN_ROOM: "JoinRoom",
        JOIN_ROOM_MESSAGE: "JoinRoomMessage",
        JOIN_ROOM_RESPONSE: "JoinRoomResponse",
        DELETE_MESSAGE: "DeleteMessage",
        REACTION: "Reaction",
        UN_REACTION: "UnReaction",
        DOWN_VOTE: "DownVote",
        UP_VOTE: "UpVote",

        RECEIVE_CREATE_MESSAGE: "ReceiveCreateMessage",
        RECEIVE_DELETE_MESSAGE: "ReceiveDeleteMessage",
        RECEIVE_UPDATE_MESSAGE: "ReceiveUpdateMessage",

        RESPONSE_UPDATE_MESSAGE: "ResponseUpdateMessage",
        RESPONSE_CREATE_MESSAGE: "ResponseCreateMessage",
        RESPONSE_DELETE_MESSAGE: "ResponseDeleteMessage",

        RESPONSE_REACT_MESSAGE: "ResponseReactMessage",
        RESPONSE_UNREACT_MESSAGE: "ResponseUnReactMessage",

        RECEIVE_REACT_MESSAGE: "ReceiveReactMessage",
        RECEIVE_UNREACT_MESSAGE: "ReceiveUnReactMessage",

        //rating
        RECEIVE_UPVOTE_MESSAGE: "ReceiveUpvoteMessage",
        RECEIVE_DOWNVOTE_MESSAGE: "ReceiveDownvoteMessage",

        RESPONSE_UPVOTE_MESSAGE: "ResponseUpvoteMessage",
        RESPONSE_DOWNVOTE_MESSAGE: "ResponseDownvoteMessage",
    },

    StorageKey: {
        USER_LOGIN: "userLogin",
        REQUEST_READ_MORE_REPLY: "requestReadMoreReply",
    },
};
